module.exports = __webpack_public_path__ + "static/06-1d7bf87130bb5588faf7c085cafa8ef5.jpg";